<template>
  <div class="detail">
    <goods-item :item="goodsDetail"></goods-item>
    <div class="line"></div>
    <div class="order-info">
      <div class="info-item disFlex fc">
        <div class="info-title">姓名：</div>
        <div class="info-content">{{orderDetail.userName}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">电话：</div>
        <div class="info-content">{{orderDetail.mobile}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">订单号：</div>
        <div class="info-content">{{orderDetail.tradeNo}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">支付状态：</div>
        <div class="info-content">{{orderDetail.payStatus?'已付款':'未付款'}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">支付方式：</div>
        <div class="info-content">{{orderDetail.payMethod}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">付款时间：</div>
        <div class="info-content">{{orderDetail.payTime}}</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="qrcode disFlex vertical fvc" v-if="useStatus==0">
      <img :src="qrcode" class="code-img" />
      <div class="code-tip">核销二维码</div>
    </div>
    <div class="use-detail" v-else-if="useStatus==1">
      <div class="title">使用详情</div>
      <div class="info-item disFlex fc">
        <div class="info-title">核销时间：</div>
        <div class="info-content">{{orderDetail.kpiUserAmountVo.finishTime}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">核销导购员：</div>
        <div class="info-content">{{orderDetail.kpiUserAmountVo.kpiUserName||'-'}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">核销门店：</div>
        <div class="info-content">{{orderDetail.kpiUserAmountVo.shopName||'-'}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">核销品牌：</div>
        <div class="info-content">{{orderDetail.kpiUserAmountVo.brandName||'-'}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">转单金额：</div>
        <div class="info-content">{{orderDetail.kpiUserAmountVo.changeAmount}}</div>
      </div>
    </div>
    <div class="f v fvc">
      <div class="back-btn" @click="backHome">返回首页</div>
    </div>
  </div>
</template>

<script>
import GoodsItem from "./../../components/goods-item";
export default {
  components: {
    GoodsItem,
  },
  data() {
    return {
      id: this.$route.query.id,
      useStatus: 0,
      goodsDetail: {},
      orderDetail: {},
      qrcode: "",
    };
  },
  created() {
    this.$store.commit("setLoading", true);
    this.getOrderDetail();
  },
  methods: {
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    getQrCode() {
      console.log(this.orderDetail.tradeNo);
      this.$http
        .get("/v1/qrcode/gen_code", {
          scene: "live_order_finish",
          addition: encodeURIComponent(
            JSON.stringify({
              id: this.id,
              tradeNo: this.orderDetail.tradeNo,
            })
          ),
        })
        .then((res) => {
          this.qrcode = res.data.qrcodePath;
        });
    },
    getOrderDetail() {
      this.$http
        .post(`/v1/orders/live_order_detail?orderId=${this.id}`, {})

        .then((res) => {
          this.$store.commit("setLoading", false);

          this.orderDetail = res.data;
          this.goodsDetail = {
            orderNo: res.data.tradeNo,
            pic: res.data.pic,
            productName: res.data.productName,
            seckillPrice: res.data.seckillPrice,
            salePrice: res.data.salePrice,
            num: res.data.num,
            payStatus: res.data.payStatus,
          };
          if (res.data.status === "active") {
            this.useStatus = 0;
            this.getQrCode();
          } else if (res.data.status === "finish") {
            this.useStatus = 1;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  height: 100vh;
  background: #fff;
  padding: 0 15px;
  .qrcode {
    padding-top: 20px;
  }
  .code-img {
    width: 150px;
    height: 150px;
    background: rgba(208, 208, 208, 1);
    margin-bottom: 15px;
  }
  .code-tip {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
  .back-btn {
    width: 133px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
    margin: 20px 0 10px;
  }
  .line {
    width: 375px;
    height: 5px;
    background: rgba(245, 246, 247, 1);
    position: relative;
    left: -15px;
  }
  .order-info {
    padding: 15px 0;
  }
  .info-item {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 24px;
    .info-title {
      width: 73px;
    }
  }
  .use-detail {
    padding: 15px 0;
    .title {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
      margin-bottom: 15px;
    }
  }
}
</style>